import {forEach} from "../../js/helpers";

forEach(document.querySelectorAll('.header'), $header => document.documentElement.style.setProperty('--header-height', $header.offsetHeight + 'px'));
